import React, { useState } from 'react';
import "./styles/main.css";
import avatar from "assets/images/profile-picture-girl-1.jpeg";
import Icon from "components/Icon";
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import Contact from "./Contact";
import OptionsBtn from "components/OptionsButton";
import { useUsersContext } from "context/usersContext";
import TopBarFilter from "../TopBarFilter";
import ShowChartIcon from '@mui/icons-material/BarChart';
import SearchIcon from '@mui/icons-material/Search';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import DialogContentText from '@mui/material/DialogContentText';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Charts from './Charts';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import CloseIcon from '@mui/icons-material/Close';
import IconButton from '@mui/material/IconButton';
import Cookies from 'js-cookie';
import searchStringUtil from 'utils/searchStringUtil';
import searchByContactIdUtil from 'utils/searchByContactIdUtil';
import Snackbar from '@mui/material/Snackbar';

const Sidebar = () => {
    const { users: contacts } = useUsersContext();
    const [filter, setFilter] = useState('all');
    const [searchTerm, setSearchTerm] = useState("");
    const [onlyVendors, setOnlyVendors] = useState(false);
    const [chartOpen, setChartOpen] = useState(false);
    const [searchOpen, setSearchOpen] = useState(false);
    const [searchString, setSearchString] = useState("");
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [searchResults, setSearchResults] = useState([]);
    const [chatOpen, setChatOpen] = useState(false);
    const [chatLog, setChatLog] = useState([]);
	const [noDates, setNoDates] = useState(false);

	const [phoneChecked, setPhoneChecked] = useState(false);
    const [nameChecked, setNameChecked] = useState(false);
    const [keywordChecked, setKeywordChecked] = useState(false);
    const [searchAlertOpen, setSearchAlertOpen] = useState(false);
    const [searchAlertMessage, setSearchAlertMessage] = useState('');


    const handleLogOut = () => {
        window.location.replace("/");
    };

    const handleChange = (event) => {
        console.log('handleChange was clicked');
        setSearchTerm(event.target.value);
    };

    const filterMap = (value) => {
        switch (value) {
            case 'all':
                return null;
            case 'open':
                return 1;
            case 'pending':
                return 2;
            case 'closed':
                return 3;
            default:
                return null;
        }
    };

    // let filteredContacts = onlyVendors ? contacts.filter(contact => contact.botStatus === filterMap(filter) && contact.provider === onlyVendors) : contacts.filter(contact => contact.botStatus === filterMap(filter));
    let filteredContacts = onlyVendors ? contacts.filter(contact => contact.botStatus === filterMap(filter) && contact.provider === true) 
    : contacts.filter(contact => contact.botStatus === filterMap(filter) &&  contact.provider !== true);

    if (filteredContacts !== null) {
        if (searchTerm) {
            filteredContacts = contacts.filter((contact) => {
                const nameMatch = contact.name ? contact.name.includes(searchTerm) : '';
                const phoneMatch = contact.phone ? contact.phone.includes(searchTerm) : '';
                const messageMatch = Object.values(contact.messages).some((messagesArray) =>
                    messagesArray.some((message) =>
                        message.body?.includes(searchTerm)
                    )
                );

                return nameMatch || phoneMatch || messageMatch;
            });
        }
    }

    const handleFilterChange = (newFilter) => {
        setFilter(newFilter);
    };

    const handleOnlyVendors = (vendors) => {
        setOnlyVendors(vendors);
    };

    const resetFields = () => {
        setSearchString("");
        setStartDate('');
        setEndDate('');
        setNoDates(false);
        setSearchResults([]);
        setPhoneChecked(false);
        setNameChecked(false);
        setKeywordChecked(false);

    };

    const openChart = () => {
        setChartOpen(true);
    };

    const closeChart = () => {
        setChartOpen(false);
    };

    const openSearch = () => {
        resetFields();
        setSearchOpen(true);
    };

    const closeSearch = () => {
        resetFields();
        setSearchOpen(false);
    };

    const handleSearch = async () => {
        if (!nameChecked && !phoneChecked && !keywordChecked) {
            setSearchAlertMessage("יש לבחור אחת מאופציות החיפוש, לפי שם טלפון או מילת חיפוש");
            setSearchAlertOpen(true);

            return; 
        }

        if (!searchString.trim()) {
            setSearchAlertMessage("שדה החיפוש לא יכול להיות ריק");
            setSearchAlertOpen(true);

            return; 
        }
    
        let dateFilter = true;
        if (noDates) {
            setStartDate(null);
            setEndDate(null);
            dateFilter = false;
        }

        let searchBy = '';
        if (phoneChecked) searchBy = 'phone';
        else if (nameChecked) searchBy = 'name';
        else if (keywordChecked) searchBy = 'keyword'; 

        console.log('SearchByyyyyy: ' + searchBy)
    
        const jwt = Cookies.get('_auth'); 
        const data = await searchStringUtil(jwt, searchBy, searchString, dateFilter, startDate, endDate);
        console.log('XXXXX', data.data)
        if(data.data.length > 0) {
            setSearchResults(data.data);
        }
    };

    const handleCloseSearchAlert = () => {
        setSearchAlertOpen(false);
    };

    const handleResultClick = async (contactId) => {
        // Simulate fetching a chat log.
        // setChatLog([
        //   { "body": "hello there", "createdAt": "2023-07-06T08:11:08.014+00:00", "direction": 1 },
        //   { "body": "whats app", "createdAt": "2023-07-06T08:11:08.014+00:00", "direction": 0 }
        // ]);

        const jwt = Cookies.get('_auth'); 
        const data = await searchByContactIdUtil(jwt, contactId);
        setChatLog(data.data)
        setChatOpen(true);
    };

    return (
        <aside className="sidebar">
            <header className="header">
                <div className="sidebar__avatar-wrapper">
                    <img src={avatar} alt="John Doe" className="avatar" />
                </div>
                <div className="sidebar__actions">
                    <button className="sidebar__action" aria-label="Show chart" onClick={openChart}>
                        <ShowChartIcon />
                    </button>
                    <button className="sidebar__action" aria-label="Search" onClick={openSearch}>
                        <SearchIcon />
                    </button>
                    <OptionsBtn
                        className="sidebar__action"
                        ariaLabel="Menu"
                        iconId="menu"
                        iconClassName="sidebar__action-icon"
                        options={[
                            "New group",
                            "Create a room",
                            "Profile",
                            "Archived",
                            "Starred",
                            "Settings",
                            "Log out",
                        ]}
                    />
                </div>
            </header>
			<Dialog open={chartOpen} onClose={closeChart}>
				<DialogTitle>
					Charts
					<IconButton style={{position: 'absolute', right: '10px', top: '10px'}} onClick={closeChart}>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				<Charts />
			</Dialog>

			<Dialog open={searchOpen} onClose={closeSearch} fullWidth>
            <DialogTitle style={{ textAlign: 'center' }}>
					חיפוש מתקדם
					<IconButton style={{position: 'absolute', right: '10px', top: '10px'}} onClick={closeSearch}>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				<DialogContent style={{direction: 'rtl'}}>
					<TextField
						autoFocus
						margin="dense"
						id="searchString"
						label="חיפוש לפי מילה טלפון או שם"
						type="text"
						fullWidth
						value={searchString}
						onChange={(e) => setSearchString(e.target.value)}
                        dir="rtl"
                        InputLabelProps={{
                            style: { textAlign: 'right' },
                        }}
                    
                        />
					<TextField
						id="startDate"
						label="תאריך התחלה"
						type="date"
						value={startDate}
						onChange={(e) => setStartDate(e.target.value)}
						InputLabelProps={{
							shrink: true,
                            style: { textAlign: 'right' },
						}}
                        
						disabled={noDates}
                        
					/>
					<TextField
						id="endDate"
						label="תאריך סיום"
						type="date"
						value={endDate}
						onChange={(e) => setEndDate(e.target.value)}
						InputLabelProps={{
							shrink: true,
                            style: { textAlign: 'right' },
						}}
						disabled={noDates}
					/>
              
              <div>
              <FormControlLabel
                    control={
                        <Checkbox 
                            checked={noDates} 
                            onChange={(e) => setNoDates(e.target.checked)}
                            disabled={!keywordChecked}  // NoDates is enabled only when Keyword is checked
                        />
                    }
                    label="ללא תאריכים"
                />

                <FormControlLabel
                    control={
                        <Checkbox 
                            checked={phoneChecked} 
                            onChange={(e) => {
                                setPhoneChecked(e.target.checked);
                                if (e.target.checked) {
                                    setNameChecked(false);
                                    setKeywordChecked(false);
                                    setNoDates(false);  // Reset NoDates when Phone is checked
                                }
                            }}
                            disabled={nameChecked || keywordChecked}
                        />
                    }
                    label="טלפון"
                />

                <FormControlLabel
                    control={
                        <Checkbox 
                            checked={nameChecked} 
                            onChange={(e) => {
                                setNameChecked(e.target.checked);
                                if (e.target.checked) {
                                    setPhoneChecked(false);
                                    setKeywordChecked(false);
                                    setNoDates(false);  // Reset NoDates when Name is checked
                                }
                            }}
                            disabled={phoneChecked || keywordChecked}
                        />
                    }
                    label="שם"
                />

                <FormControlLabel
                    control={
                        <Checkbox 
                            checked={keywordChecked} 
                            onChange={(e) => {
                                setKeywordChecked(e.target.checked);
                                if (!e.target.checked) {  // If unchecking Keyword, NoDates should also be unchecked
                                    setNoDates(false);
                                }
                                if (e.target.checked) {
                                    setPhoneChecked(false);
                                    setNameChecked(false);
                                }
                            }}
                            disabled={phoneChecked || nameChecked}
                        />
                    }
                    label="טקסט"
                />
            </div>
				</DialogContent>
				<DialogActions>
                    <Button onClick={resetFields}>נקה</Button>
					<Button onClick={closeSearch}>ביטול</Button>
					<Button onClick={handleSearch}>חיפוש</Button>
				</DialogActions>
                <DialogContent>
                    <DialogContentText style={{ textAlign: 'right' }}>
                    תוצאות
                    </DialogContentText>
                    <List>
                        {searchResults.map((result, index) => (
                            <ListItem button key={index} onClick={() => handleResultClick(result.contactId)}>
                                <ListItemText primary={result.body} secondary={result.phoneNumber} />
                            </ListItem>
                        ))}
                    </List>
                </DialogContent>
                <Snackbar
                    open={searchAlertOpen}
                    autoHideDuration={10000}
                    onClose={handleCloseSearchAlert}
                    anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                >
                    <Alert onClose={handleCloseSearchAlert} severity="error">
                        <AlertTitle>שגיאה</AlertTitle>
                        {searchAlertMessage}
                    </Alert>
                </Snackbar>
			</Dialog>

			<Dialog open={chatOpen} onClose={() => setChatOpen(false)} fullWidth>
				<DialogTitle>
					{searchResults.length > 0 ? searchResults[0].phoneNumber : ""}
					<IconButton style={{position: 'absolute', right: '10px', top: '10px'}} onClick={() => setChatOpen(false)}>
						<CloseIcon />
					</IconButton>
				</DialogTitle>
				<DialogContent>
					{chatLog.map((message, index) => (
						<div key={index} style={{
							width: '70%',
							margin: '10px',
							padding: '10px',
							backgroundColor: message.direction === 1 ? '#DCF8C6' : '#ECE5DD',
							borderRadius: '10px',
							float: message.direction === 1 ? 'right' : 'left',
							clear: 'both'
						}}>
							{message.body}
							<div style={{
								fontSize: 'small',
								color: 'gray',
								textAlign: 'right',
								paddingTop: '5px'
							}}>
								{new Date(message.createdAt).toLocaleDateString()} {new Date(message.createdAt).toLocaleTimeString()}
							</div>
						</div>
					))}
				</DialogContent>
				<DialogActions>
					<Button onClick={() => setChatOpen(false)}>סגור</Button>
				</DialogActions>
			</Dialog>


            <div className="sidebar__action">
                <TopBarFilter onOnlyVendors={handleOnlyVendors} onFilterChange={handleFilterChange} data={contacts} />
            </div>
            <div className="search-wrapper">
                <div className="search-icons">
                    <Icon id="search" className="search-icon" />
                    <button className="search__back-btn">
                        <Icon id="back" />
                    </button>
                </div>
                <input className="search"
                    placeholder="Search or start a new chat"
                    value={searchTerm}
                    onChange={handleChange}
                />
            </div>
            <div className="sidebar__contacts">
                {filteredContacts
                    .map((contact, index) => contact)
                    .sort((a, b) => new Date(b.lastMessageTime) - new Date(a.lastMessageTime))
                    .map((sortedContact, index) => (
                        <Contact key={index} contact={sortedContact} />
                    ))
                }
            </div>
        </aside>
    );
};

export default Sidebar;
